import { Navigate } from 'react-router-dom';
import { roleHasPageAccess } from 'src/auth/rbac';
import { useUserRole } from 'src/hooks/useUserRole';
import { Role } from 'src/@types/role';
import DefaultHomeRoute from 'src/layouts/app/nav/DefaultHomeRoute';
import { useUser } from 'src/hooks/query/userHooks';
import LoadingScreen from 'src/components/loading-screen';
import { ReactElement } from 'react';
import { useCurrentOrgContext } from 'src/contexts/OrgContext';
import { useOrg } from 'src/hooks/query/orgHooks';
import { Features, orgHasPermission } from './fbac';

type RoleBasedGuardProps = {
  path: string;
  features?: Features[];
  element: ReactElement | (() => ReactElement);
};

const RoleBasedGuard: React.FC<RoleBasedGuardProps> = ({ path, features = [], element }) => {
  const { data: currentUser, status: currentUserStatus } = useUser();
  const { data: role, isPending: userRoleLoading } = useUserRole();

  const { orgId } = useCurrentOrgContext();
  const { data: org, isSuccess: orgLoaded } = useOrg();

  if (
    userRoleLoading ||
    currentUserStatus === 'pending' ||
    role == undefined ||
    (orgId && !orgLoaded) ||
    orgId === undefined ||
    !org
  ) {
    return <LoadingScreen />;
  } else {
    if (currentUserStatus === 'success' && !currentUser?.has_registered) {
      return <Navigate to="/registration" />;
    }

    const orgHasAccess =
      !features || features.length === 0 || (org && !!features && orgHasPermission(org, features));

    if (orgHasAccess && roleHasPageAccess(path, role))
      return typeof element === 'function' ? element() : element;

    return <Navigate to={DefaultHomeRoute[role as Role]} replace />;
  }
};

export default RoleBasedGuard;
